import axiosService from "./axios-service";

export const getOutletPer = async (client_id, month, year, channel) => {
  var monthly;
  var quarterly;
  var data;
  var channel = channel;
  var product = "";
  if (month === "1Q" || month === "2Q" || month === "3Q" || month === "4Q") {
    quarterly = `${month.slice(0, 1)}-${year}`;
    data = { client_id, quarterly, product, channel };
  } else {
    monthly = `${month}-${year}`;
    data = { client_id, monthly, product, channel };
  }
  try {
    const response = await axiosService.post(
      "/sales/incentive/outlet_sales_target",
      data
    );
    return response.data || response;
  } catch (error) {
    console.error(error);
  }
};
export const getOutletSales = async (client_id, month, year) => {
  var monthly;
  var quarterly;
  var data;
  var product = "";
  if (month === "1Q" || month === "2Q" || month === "3Q" || month === "4Q") {
    quarterly = `${month.slice(0, 1)}-${year}`;
    data = { client_id, quarterly, product };
  } else {
    monthly = `${month}-${year}`;
    data = { client_id, monthly, product };
  }
  try {
    const response = await axiosService.post(
      "/sales/incentive/outlet_sales_count",
      data
    );

    return response.data || response;
  } catch (error) {
    console.error(error);
  }
};

export const getEmployeePer = async (client_id, month, year) => {
  var monthly;
  var quarterly;
  var data;
  var product = "";
  if (month === "1Q" || month === "2Q" || month === "3Q" || month === "4Q") {
    quarterly = `${month.slice(0, 1)}-${year}`;
    data = { client_id, quarterly, product };
  } else {
    monthly = `${month}-${year}`;
    data = { client_id, monthly, product };
  }
  try {
    const response = await axiosService.post(
      "/sales/incentive/top_ten_sales_target",
      data
    );

    return response.data || response;
  } catch (error) {
    console.error(error);
  }
};
export const getRegionPer = async (client_id, month, year) => {
  var monthly;
  var quarterly;
  var data;
  var product = "";
  if (month === "1Q" || month === "2Q" || month === "3Q" || month === "4Q") {
    quarterly = `${month.slice(0, 1)}-${year}`;
    data = { client_id, quarterly, product };
  } else {
    monthly = `${month}-${year}`;
    data = { client_id, monthly, product };
  }
  try {
    const response = await axiosService.post(
      "/sales/incentive/region_sales_target",
      data
    );

    return response.data || response;
  } catch (error) {
    console.error(error);
  }
};
export const getRegionSale = async (client_id, month, year) => {
  var monthly;
  var quarterly;
  var data;
  var product = "";
  if (month === "1Q" || month === "2Q" || month === "3Q" || month === "4Q") {
    quarterly = `${month.slice(0, 1)}-${year}`;
    data = { client_id, quarterly, product };
  } else {
    monthly = `${month}-${year}`;
    data = { client_id, monthly, product };
  }
  try {
    const response = await axiosService.post(
      "/sales/incentive/region_sales_count",
      data
    );

    return response.data || response;
  } catch (error) {
    console.error(error);
  }
};

export const getTopEmp = async (client_id, month, year) => {
  var monthly;
  var quarterly;
  var data;
  var product = "";
  if (month === "1Q" || month === "2Q" || month === "3Q" || month === "4Q") {
    quarterly = `${month.slice(0, 1)}-${year}`;
    data = { client_id, quarterly, product };
  } else {
    monthly = `${month}-${year}`;
    data = { client_id, monthly, product };
  }
  try {
    const response = await axiosService.post(
      "/sales/incentive/top_ten_sales_count",
      data
    );

    return response.data || response;
  } catch (error) {
    console.error(error);
  }
};
